// extracted by mini-css-extract-plugin
export default {"loading-wrapper":"LoadingSpinner_loading-wrapper__JmVBX","loading-div":"LoadingSpinner_loading-div__ra8ND"};